import {EntityService} from '../../../service/EntityService';

export class FormulaTypeService extends EntityService {

  static entity = 'app/formula-types';

}
